class PreviusMessagesService {
  loadedCdrs = new Map();
  makeKey(cdr) {
    return `${cdr}`;
  }

  hasThisData(cdr) {
    const key = this.makeKey(cdr);
    return this.loadedCdrs.has(key);
  }
  setLoadedCdrs(cdr, cdrsData) {
    if (this.hasThisData(cdr)) {
      return;
    }

    const key = this.makeKey(cdr);
    this.loadedCdrs.set(key, cdrsData);
  }
  getLoadedCdrs(cdr) {
    const key = this.makeKey(cdr);
    if (!this.loadedCdrs.has(key)) {
      return [];
    }
    return this.loadedCdrs.get(key);
  }
  removeLoadedCdrsByCdr(cdr) {
    const key = this.makeKey(cdr);
    if (!this.loadedCdrs.has(key)) return;
    this.loadedCdrs.delete(key);
  }
  clearAllLoadedCdrs() {
    this.loadedCdrs.clear();
  }
}

export const previusMessagesService = new PreviusMessagesService();
